import { BellTwoTone } from "@ant-design/icons";
import { ModalButton } from "../../../components/ModalButton";
import { Spacer } from "../../../components/common/Spacer";
import { Typography } from "antd";
import { iOS, isSafari } from "lib/isSafari";
import {
	pushNotificacionSubscription,
	unsubscribePushNotifications,
} from "lib/subscribeToPushNotifications";
import { useHistory } from "react-router-dom";

import React from "react";
import styled from "styled-components";
const { Text } = Typography;

const NotificationModal = ({
	onClose,
	setModalState,
	setPreferences,
	user,
}) => {
	const history = useHistory();
	const handlerModalConfirmation = () => {
		setPreferences((i) => ({ ...i, push: true }));
		pushNotificacionSubscription(user);
		setModalState("closed");
	};

	const dontShowAnymore = () => {
		setPreferences((i) => ({
			...i,
			push: false,
			never_show_popup_notifications: true,
		}));
		setModalState("closed");
	};

	const goToFAQ = () => history.push("/faq");

	return (
		<StyledContainer>
			<StyledModal>
				<Spacer rows={0.5} />
				<StyledDiv>
					<BellTwoTone
						style={{ fontSize: 30 }}
						twoToneColor="#145AB4"
					/>
					<Spacer rows={0.5} />
					<Text className="title_notification-modal">
						¡Queremos ahorrarte tiempo!
					</Text>
					<Spacer rows={0.5} />

					{isSafari || iOS ? (
						<>
							<Text>
								Las notificaciones en dispositivos iOS no son
								compatibles por el momento
							</Text>
							<Spacer rows={0.3} />
							<Text>
								Aun así, puedes activarlas desde ya para cuando
								estén disponibles
							</Text>
						</>
					) : (
						<Text>
							Te notificaremos sobre el estado de tus
							tickets,reservas y tiempo de espera para tu turno
						</Text>
					)}

					<Spacer rows={0.7} />
					<ButtonWrapper>
						<ModalButton
							onClick={() => handlerModalConfirmation()}
							loading={false}
							type={"primary"}
							label="Activar notificaciones"
						/>
						<Spacer rows={0.5} />
						<ModalButton
							onClick={onClose}
							loading={false}
							type={"backgroundLess"}
							label="En otro momento"
						/>
					</ButtonWrapper>
					<Spacer rows={1} />
					<Text
						onClick={dontShowAnymore}
						className="text-label-notifications"
					>
						No mostrar más este mensaje
					</Text>
				</StyledDiv>
				<NotificationFooter>
					<Text>
						¿No te llegan las notificaciones?
						<span
							className="link-notification-modal"
							onClick={goToFAQ}
						>
							Mira este tutorial
						</span>
					</Text>
				</NotificationFooter>
			</StyledModal>
		</StyledContainer>
	);
};
export default NotificationModal;

const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;

	& button {
		width: 90%;
		font-size: 14px;
	}
	@media (min-width: 768px) {
		& button {
			width: 60%;
		}
	}
`;

const NotificationFooter = styled.div`
	background-color: #f5f5f9;
	width: 100%;
	border-radius: 0px 0px 20px 20px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;

	.link-notification-modal {
		margin-left: 10px;
		cursor: pointer;
		color: #145ab4;
		:hover {
			text-decoration: underline;
		}
	}
`;
const StyledContainer = styled.div`
	background: rgba(0, 0, 0, 0.24);
	margin: 0 auto;
	position: fixed;
	top: 0;
	z-index: 1000;
	width: 100%;
	height: 100vh;
	display: flex;
	align-items: center;
	& .text-label-notifications {
		font-size: 12px;
		color: #145ab4;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
	& .title_notification-modal {
		font-weight: 700;
		font-size: 16px;
		color: #145ab4;
	}
`;

const StyledModal = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	width: 85%;
	max-height: 460px;
	min-height: 430px;
	text-align: center;
	background: #fefefe;
	font-family: "Montserrat";
	margin: 0 auto;
	border-radius: 20px;
	box-shadow: 0px 0px 7px 2px rgba(0, 0, 0, 0.4);
	@media (min-width: 768px) {
		width: 415px;
	}
`;

const StyledDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-self: center;
	justify-content: center;
	width: 85%;
	height: 90%;
	margin: 0 auto;
`;
